<div class="page">
  <app-page-header page-title="deadlines.documentsList.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'deadlines.documentsList.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportDeadlines')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="endDate"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="property">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'deadlines.fields.property' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <a routerLink="../../../properties/{{ element.propertyId._id}}/home">
                      <div
                        [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired), 'document-wrapper-text-not-mandatory': (!element.mandatory || element.expired)}">
                        {{ element.propertyId.name }}</div>
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="propertyFilter" [matAutocomplete]="propertyAuto">
                      <mat-autocomplete autoActiveFirstOption #propertyAuto="matAutocomplete"
                        [displayWith]="displayFn.bind(this)" (onSelectionChange)="onPropertyFilterSelected($event)">
                        <mat-option *ngIf="propertyIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!propertyIsLoading">
                          <mat-option *ngFor="let property of availableProperties" [value]="property"
                            (onSelectionChange)="onPropertyFilterSelected($event)">
                            <small>{{ property.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(propertyFilter)"
                        class="reset-input-icon" *ngIf="propertyFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="masterCode">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'properties.fields.masterCode' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.propertyId?.masterCode || ('common.words.dashes' | translate) }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="masterCodeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(masterCodeFilter)"
                        class="reset-input-icon" *ngIf="masterCodeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="providerName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'deadlines.fields.providerName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      {{ element.data.ragioneSocialeFornitore }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="providerNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(providerNameFilter)"
                        class="reset-input-icon" *ngIf="providerNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="structureObjectName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'deadlines.fields.structure' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      {{ element.structureObjectName }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="structureObjectNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(structureObjectNameFilter)"
                        class="reset-input-icon" *ngIf="structureObjectNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="endDate">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'deadlines.fields.date' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      {{ element.dateExpired | dateFormat }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="endDateFilter"
                        style="cursor: pointer" />
                      <!-- <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(endDateFilter)"
                        class="reset-input-icon" *ngIf="endDateFilter.value"></mat-icon> -->
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="memoTime">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                    title="{{ 'properties.fields.memoTime' | translate }}">
                    {{ 'deadlines.fields.memoTime' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      <span *ngIf="element.data && (element.data.tempoPreavvisoDisdetta * 1) <= 730">
                        {{ element.data.tempoPreavvisoDisdetta }}
                      </span>
                      <span *ngIf="element.data && (element.data.tempoPreavvisoDisdetta * 1) > 730">
                        {{ (element.data.tempoPreavvisoDisdetta * 1) / 365 }} {{ 'deadlines.fields.years' | translate }}
                      </span>
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="memoTimeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(memoTimeFilter)"
                        class="reset-input-icon" *ngIf="memoTimeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="renewalType">
                  <th mat-header-cell *matHeaderCellDef
                    title="{{ 'properties.fields.renewalType' | translate }}">
                    {{ 'deadlines.fields.renewalType' | translate }}</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      {{ (element.data && element.data.tipoDiRinnovo && element.data.tipoDiRinnovo === 'Rinnovo automatico') ? ('common.words.tacit' | translate) : 'common.words.dashes' | translate }}
                    </div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      
                      <mat-select [formControl]="renewalTypeFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="tacit">
                          <small>{{ 'common.words.tacit' | translate }}</small>
                        </mat-option>
                        <mat-option value="false">
                          <small>{{ 'common.words.dashes' | translate }}</small>
                        </mat-option>
                      </mat-select>

                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(renewalTypeFilter)"
                        class="reset-input-icon" *ngIf="renewalTypeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="document">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-30">
                    {{ 'deadlines.fields.document' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      {{ element.type }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="documentFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(documentFilter)"
                        class="reset-input-icon" *ngIf="documentFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="area">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'properties.documents.areas.title' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <div [ngClass]="{'document-wrapper-text-mandatory-added': (element.mandatory && !element.expired)}">
                      {{ 'properties.documents.areas.' + element.area | translate }}</div>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="areaFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option *ngFor="let area of availableTypes" [value]="area.value">
                          {{ area.label }}
                        </mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(areaFilter)"
                        class="reset-input-icon" *ngIf="areaFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="text-right">{{ 'common.cta.actions' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element" class="text-right">

                    <button mat-icon-button [matMenuTriggerFor]="menu" color="primary">
                      <mat-icon fontSet="fas" fontIcon="fa-ellipsis-v"></mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item
                        (click)="onToggleEditShowDocument(element.type, element.key, element.docId, element.subDocId, element.data, 'show', element.documentArchiveId, element.propertyId, '', element.subTopic, element.area, element.structureObjectId, element.expired, element.pdfmsg, element.cancellationRequestDate, element.cancellationRequestBy)">
                        <mat-icon fontSet="fal" fontIcon="fa-search" class="icon-action"></mat-icon>
                        {{ 'common.cta.viewAdditionalData' | translate }}
                      </button>
                      
                      <button mat-menu-item
                        *ngIf="loggedUserPermissions.includes('canEditDocumentsData')"
                        (click)="onToggleEditShowDocument(element.type, element.key, element.docId, element.subDocId, element.data, 'edit', element.documentArchiveId, element.propertyId, '', element.subTopic, element.area, element.structureObjectId, element.expired, element.pdfmsg, element.cancellationRequestDate, element.cancellationRequestBy)">
                        <mat-icon fontSet="fal" fontIcon="fa-pencil-alt" class="icon-action">
                        </mat-icon>
                        {{ 'common.cta.editAdditionalData' | translate }}
                      </button>
                     
                      <button mat-menu-item
                        (click)="onToggleDownloadDocument(element.propertyId._id, element.data?.document)">
                        <mat-icon fontSet="fal" fontIcon="fa-download" class="icon-action">
                        </mat-icon>
                        {{ 'common.cta.downloadFile' | translate }}
                      </button>
                      <button mat-menu-item
                        *ngIf="loggedUserPermissions.includes('canDeleteDocuments')"
                        (click)="onToggleDeleteDocument(element.documentArchiveId, element.data)">
                        <mat-icon fontSet="fal" fontIcon="fa-trash" class="icon-action"></mat-icon>
                        {{ 'common.cta.deleteDoc' | translate }}
                      </button>
                      <button mat-menu-item *ngIf="!element.contract"
                        (click)="onTogglePrintDocument(element.area, element.structureObjectName, element.subTopic, element.structureObjectName, element.type, element.key, element.docId, element.subDocId, element.data, element.propertyId, element.documentArchiveId)">
                        <mat-icon fontSet="fal" fontIcon="fa-print" class="icon-action"></mat-icon>
                        {{ 'common.cta.printQr' | translate }}
                      </button>
                      <button mat-menu-item
                        (click)="onTogglePrintModuleDoc(element.area, element.subTopic, element.structureObjectName, element.type, element.data, element.propertyId)">
                        <mat-icon fontSet="fal" fontIcon="fa-print" class="icon-action"></mat-icon>
                        {{ 'common.cta.printModuleDoc' | translate }}
                      </button>
                      
                      <button mat-menu-item *ngIf="!element.expired && element.contract && loggedUserPermissions.includes('canDeleteDocuments')"
                        (click)="onCancelContractDialogOpen(element.subTopic, element.type, element.structureObjectId, element.key, element.docId, element.subDocId, element.data, element.propertyId, element.documentArchiveId)">
                        <mat-icon fontSet="fal" fontIcon="fa-paper-plane" class="icon-action"></mat-icon>
                        {{ 'common.cta.cancellation' | translate }}
                      </button>
                      <button mat-menu-item *ngIf="!element.expired && element.contract && loggedUserPermissions.includes('canDeleteDocuments') && loggedUserRole.type !== 'master'"
                        (click)="onHandleExpiredContract(element.documentArchiveId, element.data)">
                        <mat-icon fontSet="fal" fontIcon="fa-ban" class="icon-action"></mat-icon>
                        {{ 'common.cta.disableContract' | translate }}
                      </button>
                    </mat-menu>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->